<template>
  <el-dialog
    :title="!!rowData.userId ? '编辑配置' : '新增配置'"
    :visible.sync="dialogVisible"
    width="40%"
    class="addReviewerDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="addReviewerForm" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="大区" prop="bigArea">
            <el-select
              v-model="formData.bigArea"
              placeholder="请选择"
              @change="bigAreaChange"
              :disabled="!!rowData.userId"
              clearable
            >
              <el-option
                v-for="(item,index) in bigAreaList"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="区域" prop="region">
            <el-select
              v-model="formData.region"
              :disabled="!!rowData.userId"
              clearable
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="regionRemoteMethod"
              :loading="regionLoading"
              @focus="regionFocusHandle"
            >
              <el-option v-for="(item, index) in regionList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="角色" prop="role">
            <el-select
              v-model="formData.role"
              :disabled="!!rowData.userId"
              placeholder="请选择"
              @change="roleChange"
            >
              <el-option
                v-for="(item,index) in roleList"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="审核人" prop="userName">
            <el-select
              v-model="formData.userName"
              clearable
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="userRemoteMethod"
              :loading="userLoading"
              @focus="userFocusHandle"
            >
              <el-option v-for="(item, index) in userList" :key="index" :label="item.userName" :value="item.userName" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen('addReviewerForm')">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { clueStaffCircConfigureApi } from '../../service';
import { arrayQuery } from '@/utils/utils';
export default {
  data () {
    return {
      rules: {
        bigArea: [
          { required: true, message: '请选择大区', trigger: 'change' }
        ],
        region: [
          { required: true, message: '请选择区域', trigger: 'change' }
        ],
        role: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        userName: [
          { required: true, message: '请选择审核人', trigger: 'change' }
        ]
      },
      dialogVisible: false,
      formData: {},
      regionList: [],
      userList: [],
      roleList: ['内销', 'IMC'],
      regionLoading: false,
      userLoading: false
    };
  },
  watch: {
    reviewerDialogVisible (val) {
      if (val) {
        if (this.rowData.userId) {
          this.formData = this.rowData;
          this.userRemoteMethod(this.formData.userName);
        }
      } else {
        this.formData = {};
      }
      this.$nextTick(() => {
        this.$refs.addReviewerForm.clearValidate();
      });
      this.dialogVisible = val;
    }
  },
  props: {
    reviewerDialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    bigAreaList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  methods: {
    userFocusHandle () {
      if (!this.formData.role) {
        this.$message.error('请选择角色');
      }
    },
    userRemoteMethod (query) {
      if (query && this.formData.role) {
        let params = {
          role: this.formData.role,
          keyWord: query
        };
        clueStaffCircConfigureApi.getAdminList(params).then(res => {
          if (res.status === '200') {
            this.userList = res.data;
          }
        });
      }
    },
    roleChange () {
      this.$set(this.formData, 'userName', '');
      this.formData.userId = '';
      this.userList = [];
      this.$nextTick(() => {
        this.$refs.addReviewerForm.clearValidate(['userName']);
      });
    },
    regionFocusHandle () {
      if (!this.formData.bigArea) {
        this.$message.error('请选择大区');
      }
    },
    regionRemoteMethod (query) {
      if (query && this.formData.bigArea) {
        clueStaffCircConfigureApi.getRegionList({ bigArea: this.formData.bigArea, keyWord: query }).then(res => {
          if (res.status === '200') {
            this.regionList = res.data;
          }
        });
      }
    },
    bigAreaChange () {
      this.$set(this.formData, 'region', '');
      this.regionList = [];
      this.$nextTick(() => {
        this.$refs.addReviewerForm.clearValidate(['region']);
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    submitHandlen (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            bigArea: this.formData.bigArea,
            region: this.formData.region,
            role: this.formData.role,
            userName: this.formData.userName,
            userId: arrayQuery(this.formData.userName, this.userList, 'userName').userId
          };
          if (this.rowData.userId) {
            this.$store.commit('setSubPageLoading', true);
            clueStaffCircConfigureApi.editReviewer(params).then(res => {
              if (res.status === '200') {
                this.$message.success('修改成功');
                this.$emit('reviewerSubmit');
              }
              this.$store.commit('setSubPageLoading', false);
            });
          } else {
            this.$store.commit('setSubPageLoading', true);
            clueStaffCircConfigureApi.addReviewer(params).then(res => {
              if (res.status === '200') {
                this.$message.success('添加成功');
                this.$emit('reviewerSubmit');
              }
              this.$store.commit('setSubPageLoading', false);
            });
          }
        }
      });
    }
  },
  mounted () {
  }
};
</script>

<style lang="scss" scoped>

</style>
